import { useLanguage } from '../lib/LanguageContext';
import { TermsOfServiceEN } from './TermsOfServiceEN';
import { TermsOfServiceCS } from './TermsOfServiceCS';
import { TermsOfServiceDE } from './TermsOfServiceDE';
import { TermsOfServiceES } from './TermsOfServiceES';
import { TermsOfServiceFR } from './TermsOfServiceFR';
import { TermsOfServiceIT } from './TermsOfServiceIT';
import { TermsOfServicePL } from './TermsOfServicePL';
import { TermsOfServicePT } from './TermsOfServicePT';
import { TermsOfServiceNL } from './TermsOfServiceNL';

export function TermsOfService() {
  const { language } = useLanguage();

  switch (language) {
    case 'cs':
      return <TermsOfServiceCS />;
    case 'de':
      return <TermsOfServiceDE />;
    case 'es':
      return <TermsOfServiceES />;
    case 'fr':
      return <TermsOfServiceFR />;
    case 'it':
      return <TermsOfServiceIT />;
    case 'pl':
      return <TermsOfServicePL />;
    case 'pt':
      return <TermsOfServicePT />;
    case 'nl':
      return <TermsOfServiceNL />;
    default:
      return <TermsOfServiceEN />;
  }
}
